module.exports = __webpack_public_path__ + "img/Arrow-Left-icon.dfe89817.png";